import { useClipboard } from '@vueuse/core';
import { message } from '@/utils/message';

const { copy, isSupported } = useClipboard();
function handleCopy(copyContent, showCopyContent) {
    if (!isSupported) {
        message.error('您的浏览器不支持Clipboard API');
        return;
    }
    if (!copyContent) {
        message.error('请输入要复制的内容');
        return;
    }
    copy(copyContent);
    if (true === showCopyContent) {
        message.success(`复制成功：${copyContent}`);
    }else {
        message.success(`复制成功`);
    }
}

export const copyContent = (copyContent, ...showCopyContent) => {
    if (!copyContent) {
        handleCopy('无拷贝内容', false);
    } else {
        handleCopy(copyContent, showCopyContent);
    }
};

export const generateSortNextCharacter = (currentChar) => {
    if (!currentChar) {
        return 'A';
    }

    const charCodeA = 'A'.charCodeAt(0);
    const charCodeZ = 'Z'.charCodeAt(0);
    const charCodeLast = currentChar.charCodeAt(currentChar.length - 1);
    let charPrefix = currentChar.substring(0, currentChar.length - 1);

    if (charCodeLast === charCodeZ) {
        // 前面两位变成A
        charPrefix = '';
        for (let i = 0; i < currentChar.length; i++) {
            charPrefix = charPrefix + 'A';
        }
    }

    if (charCodeLast < charCodeZ) {
        return charPrefix + String.fromCharCode(charCodeLast + 1);
    } else {
        const nextCharCode = (charCodeLast - charCodeA + 1) % 26 + charCodeA;
        return charPrefix + String.fromCharCode(nextCharCode);
    }
};
